import type { Metric, ViewConfigKpi } from '../../schemas/view_config/kpi.ts'

/**
 * ViewConfigKpi の inline shape (sheet/measure/date/user) から Metric を組み立てる純粋関数。
 * 本体 PR で formula tree 化されると
 * `getMetricFromKpiFormula(config.formula)` 等に置き換えられて削除される。
 */
export const viewConfigKpiToMetric = (config: ViewConfigKpi): Metric | undefined => {
  if (config.sheet === undefined || config.measure === undefined) return undefined
  return {
    sheet: config.sheet,
    measure: config.measure,
    date: config.date,
    user: config.user,
  }
}
